
<template>
	<section>
		<div v-if="type==='edit'">
			<vFormItem inline label="事务项:" labelWidth="auto" required prop="workOrderTypeId">
				<vSelect v-model="formData.workOrderTypeId" clearable>
					<vOption v-for="item in transactionOpts" :key="item.value" :value="item.value">{{item.label}}</vOption>
				</vSelect>
			</vFormItem>
			<vFormItem label-width="auto" inline label="SKU:">
				<vInput v-model="formData.sku" readonly suffix="search" @on-icon-click="handleSkuErp"></vInput>
			</vFormItem>
			<!-- <vFormItem inline label="SKU:" labelWidth="auto">
				<vSelect v-model="formData.sku" clearable>
					<vOption v-for="item in skuList" :key="item.value" :value="item.value">{{item.label}}</vOption>
				</vSelect>
			</vFormItem>-->
			<vFormItem inline label="数量:" labelWidth="auto" required prop="qty">
				<vInputNumber v-model="formData.qty" :min="0"></vInputNumber>
			</vFormItem>
			<vFormItem v-if="isManual" inline label="费用:" labelWidth="auto">
				<vInputNumber v-model="formData.estimateCost" :min="0"></vInputNumber>
			</vFormItem>
			<vFormItem inline label="备注:" labelWidth="auto">
				<vInput v-model="formData.remark" clearable></vInput>
			</vFormItem>
			<vButton class="margin-left-10" @click="addItem" theme="primary">添加</vButton>
			<div class="margin-bottom-10">
				<vButton class="margin-left-10" @click="clearItems" theme="warning">删除</vButton>
				<vButton class="margin-left-10" @click="clearAll" theme="error">清空</vButton>
			</div>
		</div>
		<compTableList :columns="getColumns" v-bind="getTableListProps" ref="tableList"></compTableList>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="modalProps.show=false"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
			/>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>
<script>
import mixin from './mixin';
import compErpsku from './erpsku'
import {
	HttpWorkOrderItems,
	HttpWorkOrderOptionsList,
	// HttpWorkOrderSkuList,
	HttpAddWorkOrderItems,
	HttpClearWorkOrderItems,
	HttpDelWorkOrderItems} from '@/service/workorder';
import compTableList from "@components/templates/tablelist";
export default {
	props: ['activeid', 'querytype', 'orgId'],
	components: {
		compTableList,
		compErpsku
	},
	mixins: [mixin],
	data() {
		return {
			type: this.querytype || this.$route.params.type,
			id: this.activeid || this.$route.query.id,
			loading: false,
			startUp: 1,
			// skuList: [],
			formData: {

			},
			transactionOpts: [],
			modalProps: {
				show: false,
			},
		}
	},
	created() {
		this.getTransactionOpts();
	},
	computed: {
		//手工录入
		isManual() {
			const workOrderTypeId = this.formData.workOrderTypeId
			return this.transactionOpts.some(item => {
				return item.value == workOrderTypeId && item.billingSourcesType === 'MANUAL'
			})
		},
		getTableListProps() {
			return {
				ajaxRequest: HttpWorkOrderItems,
				startUp: this.startUp,
				initFormData: {
					'search[EQ_workOrderId]': this.id,
				}
			}
		},
		getColumns() {
			return [{
				type: 'selection',
				formName: 'id',
				width: this.type === 'edit' ? 60 : 0
			}, {
				title: "No",
				type: 'index',
				width: 60
			}, {
				title: "事务项",
				key: 'workOrderTypeName',
				// render: (h, { row }) => this.findRenderLabel(this.transactionOpts, row.workOrderTypeId)
			}, {
				title: "SKU",
				key: 'sku'
			}, {
				title: "处理数量",
				key: "qty",
			}, {
				title: "费用",
				key: 'estimateCost',
			}, {
				title: "备注",
				key: 'remark',
			}, {
				title: "更新时间",
				key: 'updatedAt'
			}]
		},

	},
	// watch: {
	// 	'formData.workOrderTypeId': function (val) {
	// 		if (val) {
	// 			this.getSkuList();
	// 		} else {
	// 			this.skuList = [];
	// 		}
	// 	}
	// },
	methods: {
		// 添加
		addItem() {
			if (!this.formData.workOrderTypeId || !this.formData.qty) {
				return this.$VMessage.error('请填写必输项')
			}
			HttpAddWorkOrderItems({
				...this.formData,
				workOrderId: this.id,
			}).then(res => {
				this.startUp += 1;
				this.formData = {};
			}).catch(err => {
				this.$VMessage.error(err.message);
			})
		},
		//清空所有
		clearAll() {
			this.modalProps = {
				show: true,
				title: '清空所有',
				alert: 'error',
				params: {
					id: this.id
				},
				ajaxRequest: HttpClearWorkOrderItems,
				callback: () => {
					this.startUp += 1;
				}
			}
		},
		// 删除 接收明细
		clearItems() {
			const checkedData = this.$refs.tableList.checkedData;
			if (!checkedData.length) {
				this.$VMessage.warning("请选择数据");
				return
			}
			this.modalProps = {
				show: true,
				title: '删除',
				alert: 'warning',
				params: {
					idList: checkedData
				},
				ajaxRequest: HttpDelWorkOrderItems,
				callback: () => {
					this.startUp += 1;
				}
			}
		},
		//查询ERPSKU
		handleSkuErp() {
			// const workOrderTypeId = this.formData.workOrderTypeId;
			// if (!workOrderTypeId) return;
			this.modalProps = {
				show: true,
				title: 'SKU',
				component: "compErpsku",
				showFooter: false,
				width: 1000,
				props: {
					initFormData: {
						contextId: this.orgId,
					}
				},
				on: {
					'on-data': (row) => {
						// console.log(this.workData.workLinename)
						// const { id: productId = "", sku = "",} = row;
						this.formData.sku = row.sku;
						this.formData.productId = row.productId;
						this.modalProps.show = false;
					}
				},
			}
		},
		//事务项下拉列表
		async getTransactionOpts() {
			if (this.type === 'query') return;
			HttpWorkOrderOptionsList({
				id: this.id,
			}).then(res => {
				this.transactionOpts = (res.data || []).map(item => {
					return {
						value: item.id,
						label: item.transactionName,
						billingSourcesType: item.billingSourcesType
					}
				})
			}).catch(err => {
				this.transactionOpts = [];
			})
		},
		//sku下拉列表
		// async getSkuList() {
		// 	HttpWorkOrderSkuList({
		// 		serviceWorkOrderId: this.id,
		// 		workOrderTypeId: this.formData.workOrderTypeId
		// 	}).then(res => {
		// 		this.skuList = res.data || []
		// 	}).catch(err => {
		// 		this.skuList = [];
		// 	})
		// }

	},
}
</script>
